module.exports = __webpack_public_path__ + "media/images/emblems/Huenenberg_Wappen-6a558932db969eb3f048e8271b501a29.svg";